import { Box, Typography } from "@mui/material";
import React from "react";
import Checkmark from "../../UI/CheckMark/Checkmark";
import Logo from "../../../images/LOGO.svg";
import logoTitle from "../../../images/LOGO_Title.svg";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const Confirmation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const payment_failed = queryParams.get("payment_failed");

  return (
    <Box
      sx={{
        height: "calc(100lvh - 80px)",
        overflow: "hidden",
        background: "linear-gradient(180deg, #000 38%, #1D6BAE 100%);",
        display: "flex",
        justifyContent: "center",
        /* alignItems: "center", */
        /* flexDirection:'column' */
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          margin: "0 auto",
          display: "flex",
          /* gap: "8rem", */
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {payment_failed ? (
          <div className="circle">
            <CloseIcon sx={{ color: "#fff", fontSize: "3rem" }} />
          </div>
        ) : (
          <Checkmark />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <Typography fontWeight={700} variant="h5" color={"white"}>
            {payment_failed ? "Payment Failed" : "Congratulations."}
          </Typography>
          <Typography variant="body1" color={"white"}>
            {payment_failed
              ? "Please try again"
              : "Please check your email for verification"}
          </Typography>
        </Box>
        <Box
          sx={{
            /* width: "35%", */
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "8rem",
          }}
        >
          <img src={Logo} alt={"RAWDAT"} width={250} />
          <img src={logoTitle} alt={"RAWDATAI"} width={250} />
        </Box>
      </Box>
    </Box>
  );
};

export default Confirmation;
